import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueI18n from 'vue-i18n';
import ru from './localization/ru';
import en from './localization/en';
import Maska from 'maska';
import VeeValidate, { Validator } from 'vee-validate';
import VueClickOutside from 'vue-click-outside';

import BaseTextInput from './components/base/BaseTextInput.vue';
import BaseToast from './components/base/BaseToast.vue';

import BaseButton from './components/base/BaseButton.vue';

Vue.config.productionTip = false;
window.kapystaRouter = router;

Validator.extend('organizationPhoneNumber', {
  getMessage: 'Номер телефона не верен',
  validate: value => {
    const filteredValue = value.replace(/[^\d]/g, '');

    return /(375)\d{9,9}/.test(filteredValue);
  }
});

Validator.extend('supportMessage', {
  getMessage: 'Максимальное количество символов: 300',
  validate: value => {
    return value.length >= 1 && value.length <=300;
  }
});

Validator.extend('offerCount', {
  getMessage: 'Поле не верно',
  validate: value => {
    return +value > 0;
  }
});

Validator.extend('offerRating', {
  getMessage: 'Поле не верно',
  validate: value => {
    return +value >= 0 && +value <= 100;
  }
});

Validator.extend('offerPercent', {
  getMessage: 'Поле не верно',
  validate: value => {
    const minPercent = window.entityCabinetSettings.offer.minPercent;
    const maxPercent = window.entityCabinetSettings.offer.maxPercent;
    return +value >= minPercent && +value <= maxPercent;
  }
});

Validator.extend('offerTerm', {
  getMessage: 'Поле не верно',
  validate: value => {
    const minTerm = window.entityCabinetSettings.offer.minTerm;
    const maxTerm = window.entityCabinetSettings.offer.maxTerm;
    return +value >= minTerm && +value <= maxTerm;
  }
});

Validator.extend('offerAmount', {
  getMessage: 'Поле не верно',
  validate: value => {
    const minAmount = window.entityCabinetSettings.offer.minAmount;
    const maxAmount = window.entityCabinetSettings.offer.maxAmount;
    return +value >= minAmount && +value <= maxAmount;
  }
});

Validator.extend('totalIncome', {
  getMessage: 'Поле не верно',
  validate: value => value.length >= 2
});

Validator.extend('dependensNumber', {
  getMessage: 'Поле не верно',
  validate: value => value.length >= 1
});

Validator.extend('workExperience', {
  getMessage: 'Поле не верно',
  validate: value => value.length >= 1
});

Validator.extend('otherPositionType', {
  getMessage: 'Поле не верно',
  validate: value => value.length >= 2
});

Validator.extend('nameOfOrganization', {
  getMessage: 'Поле не верно',
  validate: value => value.length >= 2
});

Validator.extend('livingAddress', {
  getMessage: 'Поле не верно',
  validate: value => value.length >= 2
});

Validator.extend('registrationAdress', {
  getMessage: 'Поле не верно',
  validate: value => value.length >= 2
});

Validator.extend('idIssuedBy', {
  getMessage: 'Поле не верно',
  validate: value => value.length >= 2
});

Validator.extend('idSeries', {
  getMessage: 'Поле не верно',
  validate: value => value.length >= 2
});

Validator.extend('birthPlace', {
  getMessage: 'Поле не верно',
  validate: value => value.length >= 2
});

Validator.extend('keyWord', {
  getMessage: 'Поле не верно',
  validate: value => value.length >= 2
});

Validator.extend('citizenship', {
  getMessage: 'Поле не верно',
  validate: value => value.length >= 2
});

Validator.extend('name', {
  getMessage: 'Поле не верно',
  validate: value => value.length >= 2
});

Validator.extend('middleName', {
  getMessage: 'Поле не верно',
  validate: value => value.length >= 2
});

Validator.extend('surname', {
  getMessage: 'Поле не верно',
  validate: value => value.length >= 2
});

Validator.extend('msisdn', {
  getMessage: 'Номер телефона не верен',
  validate: value => {
    const filteredValue = value.replace(/[^\d]/g, '');

    return /(375)\d{9,9}/.test(filteredValue);
  }
});

Validator.extend('password', {
  getMessage: 'Не менее 8 символов, минимум одна прописная и одна строчная буква, одна цифра',
  validate: value => /^(?=.*[a-z])(?=.*[A-Z]).{4,}(?=.*\d).{4,}$/.test(value)
});

Validator.extend('login', {
  getMessage: 'Логин не верен',
  validate: value => value.length >= 6
});

Validator.extend('passwordConfirmation', {
  getMessage: 'Пароли не совпадают',
  validate: (value, [otherValue]) => {
    return value === otherValue;
  },
  hasTarget: true
});

Validator.extend('loanPayConfirmation', {
  getMessage: 'Не верная сумма',
  validate: (value, [otherValue]) => {
    return Number((+value * 100).toFixed(0)) <= otherValue;
  },
  hasTarget: true
});

Validator.extend('otp', {
  getMessage: 'Код не верен',
  validate: value => value.length >= 6
});

Vue.filter('cardPan', function(value) {
  const parsedPan = value.slice(0, 4) + ' ' + value.slice(4, 8) + 
    ' ' + value.slice(8, 12) + ' ' + value.slice(12, 16);
  return parsedPan.toUpperCase();
});

Vue.filter('cardExpiry', function(value) {
  const parsedExpiry = value.slice(0, 2) + '/' + value.slice(2, 4);
  return parsedExpiry;
});

Vue.filter('offerUserName', function(value) {
  const name = value?.name_ru?.given_name_ru;
  const familyName = value?.name_ru?.family_name_ru;
  const modyfiedFamilyName = familyName.slice(0, 1) + '.';
  return `${name} ${modyfiedFamilyName}`;
});

Vue.component('base-button', BaseButton);
Vue.component('base-text-input', BaseTextInput);

Vue.use(VueAxios, axios);
Vue.use(VueI18n);
Vue.use(Maska);
Vue.use(VeeValidate);
Vue.use(VueClickOutside);

Vue.prototype.$toast = function (methodOptions) {
  let ComponentClass = Vue.extend(BaseToast);
  let toastInst = new ComponentClass({
    propsData: {
      toastMessage: methodOptions.text,
      isShown: true,
      width: methodOptions.width || 310
    }
  });
  toastInst.$mount() // pass nothing
  setTimeout(() => {
    document.getElementById('app').appendChild(toastInst.$el);
    setTimeout(() => {
      document.getElementById('app').removeChild(toastInst.$el);
    }, methodOptions.delay || 1500)
  }, 0);
}

const locale = 'ru';
const i18n = new VueI18n({
  locale,
  messages: {
    ru,
    en
  }
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
